export enum AbsenteeismChartTypes {
    All = 0,
    Absentismo = 1,
    Acumulado = 2,
    Interanual = 3
}
